"use client";

import { motion } from "motion/react";
import { Sparks } from "iconoir-react";

/**
 * Soft, warm banner shown above the wizard when a guest returns from auth but
 * their saved form data couldn't be recovered (e.g., they opened the OTP magic
 * link in a different browser, so sessionStorage was empty on resume).
 *
 * The tone is reassuring rather than apologetic — we're inviting them to
 * start again, not flagging an error.
 */
export const ResumeLostBanner = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="flex items-start gap-3 rounded-2xl bg-indigo-50/70 px-4 py-3 text-left ring-1 ring-inset ring-indigo-100"
      role="status"
    >
      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white text-indigo-600">
        <Sparks className="h-4 w-4" strokeWidth={2} />
      </span>
      <div className="flex flex-col gap-0.5">
        <p className="text-sm font-semibold text-gray-900 tracking-tight">Welcome back, let&apos;s start fresh</p>
        <p className="text-sm font-medium text-gray-700">
          We couldn&apos;t restore your earlier answers, so we&apos;ll just need them once more.
        </p>
      </div>
    </motion.div>
  );
};
